import { useDroppable } from "@dnd-kit/core";
import { CSSProperties } from "react";

interface Props {
  id: string;
  childComponent: (bool?: boolean) => React.ReactNode;
  data?: any;
  disabled?: boolean;
  style?: CSSProperties;
}

/**
 * Droppable - Basic droppable component
 * @param {string} id - A unique identifier for the Droppable. Must be unique from all other droppables in the DndContext.
 * @param {boolean} disabled - Whether or not to disabled dropping on this droppable.
 * @param {any} data - Optional, provide any data about the droppable element that you may need to access in event handlers, modifiers or custom sensors.
 * @param {function} childComponent - The component to be rendered inside of the Droppable.
 */
const Droppable = ({
  id,
  disabled = false,
  data,
  style,
  childComponent,
}: Props) => {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
    disabled: disabled,
    data: data ? data : null,
  });

  const finalStyle = {
    ...style,
    outline: isOver
      ? "1px solid var(--dropdown-selected-dark)"
      : "1px solid transparent",
    borderRadius: 6,
    backgroundColor: isOver ? "#c8f3d8" : undefined,
    transition: "background-color 0.2s ease, outline 0.2s ease",
    marginTop: 1,
  };

  return (
    <div ref={setNodeRef} style={finalStyle}>
      {childComponent(isOver)}
    </div>
  );
};

export default Droppable;
